import { HttpResponse, http } from 'msw';

import { environment } from '../../environments/environment';

const env = { ...environment };
const module = env.services.receipts;
const envServiceUrl = module.url;

const receiptsList = () => {
  return HttpResponse.json({
    content: [
      {
        receiptNo: 'RC25-CJX00168P03-000035',
        documentType: 'NEW_RTC_RECEIPT',
        deviceId: '14627c885c9577a1',
        deviceNo: 'P03 - case happy',
        merchantNo: '000002',
        merchantName: 'บริษัท ซีเจมาร์ท จำกัด',
        cashierName: 'ไออออออออออออ ซีเจนะ',
        netAmount: 241.0,
        storeCode: 'CJX00168',
        storeName:
          'ร้านรวยไม่จำกัด ( ข้าวหอมสาขา 1 ตั้งชื่อให้ยาวววววววววววววววววววววววววววววววววววววววววววววววววววววว)',
        createdDate: '2025-01-13T03:52:47.949Z',
        lastModifiedDate: '2025-01-13T03:52:47.949Z',
        receiptDate: '2025-01-13T03:52:47.251Z'
      },
      {
        receiptNo: 'RC25-CJX00168P03-000036',
        documentType: 'NEW_RTC_RECEIPT',
        deviceId: '14627c885c9577a1',
        deviceNo: 'P03 - case invalid tax id',
        merchantNo: '000002',
        merchantName: 'บริษัท ซีเจมาร์ท จำกัด',
        cashierName: 'ไออออออออออออ ซีเจนะ',
        netAmount: 241.0,
        storeCode: 'CJX00168',
        storeName:
          'ร้านรวยไม่จำกัด ( ข้าวหอมสาขา 1 ตั้งชื่อให้ยาวววววววววววววววววววววววววววววววววววววววววววววววววววววว)',
        createdDate: '2025-01-13T03:52:47.949Z',
        lastModifiedDate: '2025-01-13T03:52:47.949Z',
        receiptDate: '2025-01-13T03:52:47.251Z'
      },
      {
        receiptNo: 'RC25-CJX00168P03-000037',
        documentType: 'NEW_RTC_RECEIPT',
        deviceId: '14627c885c9577a1',
        deviceNo: 'P03 - case waiting invoice from vendor',
        merchantNo: '000002',
        merchantName: 'บริษัท ซีเจมาร์ท จำกัด',
        cashierName: 'ไออออออออออออ ซีเจนะ',
        netAmount: 241.0,
        storeCode: 'CJX00168',
        storeName:
          'ร้านรวยไม่จำกัด ( ข้าวหอมสาขา 1 ตั้งชื่อให้ยาวววววววววววววววววววววววววววววววววววววววววววววววววววววว)',
        createdDate: '2025-01-13T03:52:47.949Z',
        lastModifiedDate: '2025-01-13T03:52:47.949Z',
        receiptDate: '2025-01-13T03:52:47.251Z'
      },
      {
        receiptNo: 'RC25-CJX00168P03-000038',
        documentType: 'NEW_RTC_RECEIPT',
        deviceId: '14627c885c9577a1',
        deviceNo: 'P03 - case create already',
        merchantNo: '000002',
        merchantName: 'บริษัท ซีเจมาร์ท จำกัด',
        cashierName: 'ไออออออออออออ ซีเจนะ',
        netAmount: 241.0,
        storeCode: 'CJX00168',
        storeName:
          'ร้านรวยไม่จำกัด ( ข้าวหอมสาขา 1 ตั้งชื่อให้ยาวววววววววววววววววววววววววววววววววววววววววววววววววววววว)',
        createdDate: '2025-01-13T03:52:47.949Z',
        lastModifiedDate: '2025-01-13T03:52:47.949Z',
        receiptDate: '2025-01-13T03:52:47.251Z'
      },
      {
        receiptNo: 'RC25-CJX00168P03-000039',
        documentType: 'NEW_RTC_RECEIPT',
        deviceId: '14627c885c9577a1',
        deviceNo: 'P03 - case refund waiting credit note from vendor',
        merchantNo: '000002',
        merchantName: 'บริษัท ซีเจมาร์ท จำกัด',
        cashierName: 'ไออออออออออออ ซีเจนะ',
        netAmount: 241.0,
        storeCode: 'CJX00168',
        storeName:
          'ร้านรวยไม่จำกัด ( ข้าวหอมสาขา 1 ตั้งชื่อให้ยาวววววววววววววววววววววววววววววววววววววววววววววววววววววว)',
        createdDate: '2025-01-13T03:52:47.949Z',
        lastModifiedDate: '2025-01-13T03:52:47.949Z',
        receiptDate: '2025-01-13T03:52:47.251Z',
        isRefunded: true
      },
      {
        receiptNo: 'RC25-CJX00168P03-000040',
        documentType: 'NEW_RTC_RECEIPT',
        deviceId: '14627c885c9577a1',
        deviceNo: 'P03 - case refund not file',
        merchantNo: '000002',
        merchantName: 'บริษัท ซีเจมาร์ท จำกัด',
        cashierName: 'ไออออออออออออ ซีเจนะ',
        netAmount: 241.0,
        storeCode: 'CJX00168',
        storeName:
          'ร้านรวยไม่จำกัด ( ข้าวหอมสาขา 1 ตั้งชื่อให้ยาวววววววววววววววววววววววววววววววววววววววววววววววววววววว)',
        createdDate: '2025-01-13T03:52:47.949Z',
        lastModifiedDate: '2025-01-13T03:52:47.949Z',
        receiptDate: '2025-01-13T03:52:47.251Z',
        isRefunded: true
      },
      {
        receiptNo: 'RC25-CJX00168P03-000041',
        documentType: 'NEW_RTC_RECEIPT',
        deviceId: '14627c885c9577a1',
        deviceNo: 'P03 - case waiting reprint invoice from vendor',
        merchantNo: '000002',
        merchantName: 'บริษัท ซีเจมาร์ท จำกัด',
        cashierName: 'ไออออออออออออ ซีเจนะ',
        netAmount: 241.0,
        storeCode: 'CJX00168',
        storeName:
          'ร้านรวยไม่จำกัด ( ข้าวหอมสาขา 1 ตั้งชื่อให้ยาวววววววววววววววววววววววววววววววววววววววววววววววววววววว)',
        createdDate: '2025-01-13T03:52:47.949Z',
        lastModifiedDate: '2025-01-13T03:52:47.949Z',
        receiptDate: '2025-01-13T03:52:47.251Z'
      }
    ],
    totalElements: 617,
    totalPages: 31,
    page: 0,
    size: 20,
    numberOfElements: 20,
    first: true,
    last: false,
    empty: false,
    hasContent: true
  });
};

const viewTaxInvoice = () => {
  return HttpResponse.json(dataViewTaxInvoice('RC25-CJX00168P03-000035'));
};
const viewTaxInvoiceCaseInvalid = () => {
  return HttpResponse.json(dataViewTaxInvoice('RC25-CJX00168P03-000036'));
};
const viewTaxInvoiceCaseWaitingVendor = () => {
  return HttpResponse.json(dataViewTaxInvoice('RC25-CJX00168P03-000037'));
};
const viewTaxInvoiceCaseCreated = () => {
  return HttpResponse.json(dataViewTaxInvoice('RC25-CJX00168P03-000038', '9999', false));
};
const viewTaxInvoiceCaseRefundWaitingVendor = () => {
  return HttpResponse.json(dataViewTaxInvoice('RC25-CJX00168P03-000039', 'waitingVendor', undefined, true));
};
const viewTaxInvoiceCaseRefundNotFile = () => {
  return HttpResponse.json(dataViewTaxInvoice('RC25-CJX00168P03-000040', 'notFile', undefined, true));
};
const viewTaxInvoiceCaseReprintWaitingVendor = () => {
  return HttpResponse.json(dataViewTaxInvoice('RC25-CJX00168P03-000041'));
};

const createInvoice = async ({ request }) => {
  const requestBody = await request.json();
  if ('' + requestBody.taxId === '1111111111110') {
    return HttpResponse.json(
      {
        code: 'ET10001'
      },
      {
        status: 400,
        headers: { 'tax-invoice-no': '999' }
      }
    );
  }
  const blobData = new Blob(['Sample file content'], { type: 'text/plain' });
  return HttpResponse.json(blobData, {
    headers: { 'Content-Type': 'application/octet-stream', 'tax-invoice-no': '999' }
  });
};
const createInvoiceCaseInvalid = () => {
  return HttpResponse.json(
    {
      code: 'ET20001'
    },
    {
      status: 400
    }
  );
};
const createInvoiceCaseWaitingVendor = () => {
  return HttpResponse.json(
    {
      code: 'ET10001'
    },
    {
      status: 400,
      headers: { 'tax-invoice-no': '999' }
    }
  );
};
const createInvoiceCreated = () => {
  return HttpResponse.json(
    {
      code: 'CT0001'
    },
    {
      status: 400
    }
  );
};
const createCreditNoteWithWaitingVendor = async ({ request }) => {
  const requestBody = await request.json();
  if (requestBody.taxInvoiceNo === 'notFile') {
    return HttpResponse.json(
      {
        code: 'TCN0001'
      },
      {
        status: 400
      }
    );
  } else if (requestBody.taxInvoiceNo === 'waitingVendor') {
    return HttpResponse.json(
      {
        code: 'ET10002',
        value: '000'
      },
      {
        status: 400
      }
    );
  }

  return HttpResponse.json();
};

export const handlers = [
  http.get(env.serverUrl + envServiceUrl + '/stores/000069/receipts', receiptsList),
  http.get(env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000035', viewTaxInvoice),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000036',
    viewTaxInvoiceCaseInvalid
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000037',
    viewTaxInvoiceCaseWaitingVendor
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000038',
    viewTaxInvoiceCaseCreated
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000039',
    viewTaxInvoiceCaseRefundWaitingVendor
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000040',
    viewTaxInvoiceCaseRefundNotFile
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000041',
    viewTaxInvoiceCaseReprintWaitingVendor
  ),
  http.post(env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000035/tax-invoices', () => {
    return HttpResponse.json(
      {},
      {
        headers: { 'Content-Type': 'application/octet-stream', 'tax-invoice-no': '1111111111110' }
      }
    );
  }),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000035/tax-invoices/validate',
    HttpResponse.json
  ),
  http.post(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000036/tax-invoices',
    createInvoiceCaseInvalid
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000036/tax-invoices/validate',
    HttpResponse.json
  ),
  http.post(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000037/tax-invoices',
    createInvoiceCaseWaitingVendor
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000037/tax-invoices/validate',
    HttpResponse.json
  ),
  http.post(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000038/tax-invoices',
    createInvoiceCreated
  ),
  http.post(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000041/tax-invoices',
    HttpResponse.json
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000038/tax-invoices/validate',
    HttpResponse.json
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000039/tax-invoices/validate',
    HttpResponse.json
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000040/tax-invoices/validate',
    HttpResponse.json
  ),
  http.get(
    env.serverUrl + envServiceUrl + '/stores/000069/receipts/RC25-CJX00168P03-000041/tax-invoices/validate',
    HttpResponse.json
  ),
  http.post(env.serverUrl + envServiceUrl + '/stores/000069/tax-invoices/reprint', createInvoice),
  http.post(
    env.serverUrl + envServiceUrl + '/stores/000069/refund/tax-credit-note/print',
    createCreditNoteWithWaitingVendor
  )
];

const dataViewTaxInvoice = (receiptNo: string, invoiceNo?: string, etaxGenerated?: boolean, isRefund?: boolean) => {
  return {
    receiptNo: receiptNo,
    receiptDate: '2025-01-13T03:52:47.251Z',
    documentType: 'NEW_RTC_RECEIPT',
    deviceId: '14627c885c9577a1',
    deviceNo: 'P03',
    merchantNo: '000002',
    merchantName: 'บริษัท ซีเจมาร์ท จำกัด',
    cashierName: 'ไออออออออออออ ซีเจนะ',
    amountBeforeDiscount: 241.0,
    netAmount: 241.0,
    totalQty: 9,
    storeCode: 'CJX00168',
    storeName: 'ร้านรวยไม่จำกัด ( ข้าวหอมสาขา 1 ตั้งชื่อให้ยาวววววววววววววววววววววววววววววววววววววววววววววววววววววว)',
    createdDate: '2025-01-13T03:52:47.949Z',
    lastModifiedDate: '2025-01-13T03:52:47.949Z',
    invoiceNo: invoiceNo,
    isRefunded: isRefund,
    canceled: null,
    etaxGenerated: etaxGenerated,
    items: [
      {
        itemNo: 5,
        articleNo: '20004266',
        barcode: '8851912070542',
        productName: 'ง่วนเชียงซอสปรุงรสฉลากเขียว 600ml',
        productType: 'INVENTORY',
        qty: 3,
        pricePerUnit: 28.0,
        totalSaleAmount: 84.0,
        sign: null,
        unit: 'PC',
        unitFactor: 1
      },
      {
        itemNo: 6,
        articleNo: '12102835',
        barcode: '8858793000006',
        productName: '(004) Test -1',
        productType: 'INVENTORY',
        qty: 5,
        pricePerUnit: 2.0,
        totalSaleAmount: 10.0,
        sign: 'N',
        unit: 'PC',
        unitFactor: 1
      },
      {
        itemNo: 7,
        articleNo: '20004219',
        barcode: '8850187000018',
        productName: 'ฉัตรส้มข้าวหอมผสม (70/30) 5kg MP',
        productType: 'INVENTORY',
        qty: 1,
        pricePerUnit: 147.0,
        totalSaleAmount: 147.0,
        sign: 'N',
        unit: 'PC',
        unitFactor: 1
      }
    ],
    promotions: [],
    payments: [
      {
        paymentType: 'CASH',
        amount: 241.0,
        moneyReceive: 241.0,
        change: 0.0
      }
    ]
  };
};
